import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addVideoPosition } from '../../../../actions/continueWatching';
import {
    continueWatchingItemsSelector,
    continueWatchingActiveSelector,
} from '../../../../reducers/continueWatching';
import { nextVideoIsBingeSelector } from '../../../../reducers/videoPage';
import ContinueWatching from './ContinueWatching.jsx';

const ContinueWatchingContainer = (props) => {
    return <ContinueWatching {...props} />;
};

ContinueWatchingContainer.propTypes = {
    videoPlayer: PropTypes.object,
    position: PropTypes.number,
    duration: PropTypes.number,
    streamInfo: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        continueWatchingIsActive: continueWatchingActiveSelector(state),
        continueWatchingItems: continueWatchingItemsSelector(state),
        nextVideoIsBinge: nextVideoIsBingeSelector(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        addContinueWatchingItem: (barn, visionId, titleArticleId, __typename, position, videoLength) => {
            dispatch(addVideoPosition(barn, visionId, titleArticleId, __typename, position, videoLength));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContinueWatchingContainer);
